import { FunctionComponent } from "react";
import ProtocolLayout from "../components/ProtocolLayout";

interface StickersStarterProps {}

const StickersStarter: FunctionComponent<StickersStarterProps> = () => {
  return (
    <ProtocolLayout>
      <div className="flex flex-col items-center py-12">
        <div className="mb-12 text-3xl font-bold underline">Kazam Stickers</div>
        <div className="grid lg:grid-cols-3 justify-items-center gap-y-5 lg:gap-y-0 w-4/5 mt-6 lg:mt-20">
          <a
            href="https://drive.google.com/file/d/1oa0AQRbQoPWZGSeS7IQRPnG3mYqx-m3t/view?usp=sharing"
            target="_blank"
            rel="noreferrer"
          >
            <div className="relative bg-gray-100 hover:bg-gray-200 duration-300 w-72 h-64 flex flex-col items-center justify-center rounded-xl shadow-lg py-12 px-4 ">
              <div className="">
                {/* <img src="/docs/gmc1.png" alt="" className="w-32" /> */}
              </div>
              <div className="mt-12 text-black text-opacity-40 font-bold text-xl">
                Stickers
              </div>
            </div>
          </a>
          <a
            href="https://drive.google.com/file/d/1b5A4hb3IHRUTy0k-17yYSYeMcNN9ihaf/view?usp=drive_link"
            target="_blank"
            rel="noreferrer"
          >
            <div className="relative bg-gray-100 hover:bg-gray-200 duration-300 w-72 h-64 flex flex-col items-center justify-center rounded-xl shadow-lg py-12 px-4 ">
              <div className="">
                {/* <img src="/docs/gmc1.png" alt="" className="w-32" /> */}
              </div>
              <div className="mt-12 text-black text-opacity-40 font-bold text-xl">
                Stickers New
              </div>
            </div>
          </a>
        </div>
      </div>
    </ProtocolLayout>
  );
};

export default StickersStarter;
